import type React from 'react';
import type { AnchorHTMLAttributes } from 'react';
import type { ValueOf } from 'type-fest';
import type { replaceQueryParameters } from '~/shared/replace-query-parameters';

export const themes = {
  noUnderline: 'no-underline',
  orange: 'orange',
  blue: 'blue',
} as const;

export interface CleanLink extends AnchorHTMLAttributes<HTMLAnchorElement> {
  bold?: boolean;
  children?: React.ReactNode;
  className?: string;
  elementName?: string;
  href: string;
  query?: Parameters<typeof replaceQueryParameters>[1];
  text?: string;
  theme?: ValueOf<typeof themes>;
}
